import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';
import * as XLSX from 'node-xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExportService {
  fileType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  fileExtension = '.xlsx';

  eventsExportToCsv(data: any[], fileName: string, headers: any[]): void {
    const csvHeader: string[] = [];
    headers.forEach(x => {
      csvHeader.push(x.displayName);
    });
    if (data && data.length == 0) return;
    const replacer = (key, value) => (value === null ? '' : value);
    const header = headers.map(x => x.id);
    const csv = data.map(row =>
      header
        .map(fieldName => JSON.stringify(row[fieldName], replacer))
        .join(',')
    );
    csv.unshift(csvHeader.join(','));
    const csvArray = csv.join('\r\n');
    const blob = new Blob(['\ufeff', csvArray], { type: 'text/csv;' });
    saveAs(blob, fileName);
  }

  exportToCsv(data: any[], fileName: string): void {
    if (data && data.length == 0) return;
    const replacer = (key, value) => (value === null ? '' : value);
    const header = Object.keys(data[0]);
    const csv = data.map(row =>
      header
        .map(fieldName => JSON.stringify(row[fieldName], replacer))
        .join(',')
    );
    csv.unshift(header.join(','));
    const csvArray = csv.join('\r\n');
    const blob = new Blob(['\ufeff', csvArray], { type: 'text/csv;' });
    saveAs(blob, fileName);
  }

  exportExcel(jsonData: any[], fileName: string): void {
    const headers: string[] = Object.keys(jsonData[0]);
    const ws: XLSX.WorkSheet = {
      name: 'data',
      data: [headers, ...jsonData.map(row => Object.values(row))],
      options: {}
    };
    const xlsxData: XLSX.WorkSheet[] = [ws];
    const excelBuffer: Buffer = XLSX.build(xlsxData);
    this.saveExcelFile(excelBuffer, fileName);
  }

  private saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: this.fileType });
    saveAs(data, fileName + this.fileExtension);
  }

  createExcelBufferFromJson(jsonData: any[]) {
    const headers: string[] = Object.keys(jsonData[0]);
    const ws: XLSX.WorkSheet = {
      name: 'data',
      data: [headers, ...jsonData.map(row => Object.values(row))],
      options: {}
    };
    const xlsxData: XLSX.WorkSheet[] = [ws];
    const excelBuffer: Buffer = XLSX.build(xlsxData);
    return excelBuffer;
  }
}
